<template>
  <div class="progress-wrapper">
    <div class="progress" :style="{ width: percent + '%' }">
      <div class="progress-bg" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Process',
  props: {
    percent: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-wrapper {
  position: relative;

  width: 3rem;
  height: 0.2rem;

  background-color: #ebebeb;
  border-radius: 0.16rem;
  .progress {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    overflow: hidden;

    border-radius: 0.16rem;

    .progress-bg {
      width: 3rem;
      height: 0.2rem;

      background: url('../../../images/coupon_center/progress_bg@3x.png')
        no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
